var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "act-wrap"
  }, [_vm.wayType === 'email' ? _c('div', {
    staticClass: "email-inner"
  }, [_c('div', {
    staticClass: "notice"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.actemail'), {
    name: this.name
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn sure",
    class: {
      act: _vm.act
    },
    on: {
      "click": function click($event) {
        return _vm.register();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.complatereg'))))]), _vm._v(" "), _c('div', {
    staticClass: "btn resend",
    class: {
      act: _vm.act
    },
    on: {
      "click": function click($event) {
        return _vm.resend();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.resend'))))]), _vm._v(" "), _c('toast-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastState,
      expression: "toastState"
    }],
    attrs: {
      "txt": _vm.txt
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-email' ? _c('div', {
    staticClass: "memail-inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.signUp'))))]), _vm._v(" "), _c('div', {
    staticClass: "notice mb"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.actemail'), {
    name: this.name
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn sure mb",
    class: {
      act: _vm.act
    },
    on: {
      "click": function click($event) {
        return _vm.register();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.complatereg'))))]), _vm._v(" "), _c('div', {
    staticClass: "btn resend mb",
    class: {
      act: _vm.act
    },
    on: {
      "click": function click($event) {
        return _vm.resend();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.resend'))))]), _vm._v(" "), _c('toast-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastState,
      expression: "toastState"
    }],
    attrs: {
      "txt": _vm.txt,
      "mb": "mb"
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };